import { styled, Primitive } from '@miro-site/ui-styled-engine';
export var attributesVariants = {
  size: {
    200: {
      width: '$icon-200',
      height: '$icon-200'
    },
    300: {
      width: '$icon-300',
      height: '$icon-300'
    },
    400: {
      width: '$icon-400',
      height: '$icon-400'
    }
  },
  color: {
    ctaIdle: {
      color: '$icon-cta-idle'
    },
    "default": {
      color: '$icon-default'
    },
    defaultActive: {
      color: '$icon-default-active'
    },
    defaultDisabled: {
      color: '$icon-default-disabled'
    },
    defaultError: {
      color: '$icon-default-error'
    },
    defaultHover: {
      color: '$icon-default-hover'
    },
    defaultIdle: {
      color: '$icon-default-idle'
    },
    defaultSelected: {
      color: '$icon-default-selected'
    }
  }
};
var IconBase = styled(Primitive.svg, {
  variants: attributesVariants,
  defaultVariants: {
    size: '300',
    color: 'default'
  }
});
export default IconBase;